'use client';
import {GlobalError} from '@olympus-frontend/core/error';

// global-error must itself be a Client Component (Next convention); it renders the
// shared core boundary.
export default GlobalError;
